import { Component, OnInit, Input } from '@angular/core';
import * as $ from 'jquery';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { noWhitespaceValidator } from 'src/app/utils/no-whitespace.validator';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import { GeneralService } from 'src/app/services/general.service';
import { selectConfig } from 'src/app/utils/utils';
import { Observable, forkJoin } from 'rxjs';
import { DealsService } from 'src/app/services/deals.service';
import { EmailClientService } from 'src/app/services/integrations/email/email-client.service';
import { SignupLoginService } from 'src/app/services/signupLogin.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-task-modal',
  templateUrl: './task-modal.component.html',
  styleUrls: ['./task-modal.component.css']
})

export class TaskModalComponent implements OnInit {
  user;
  mytime;
  @Input() showTask = false;
  @Input() modalId = "task-modal";
  isLoading: boolean = false;
  showLoading: boolean = false;
  restricDateTYP = new Date();
  clientList;
  dealList$: Observable<any>;
  supervisorAttachedUsers: any = [];
  salesperson_config = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Select Salesperson", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search salesperson",
    displayKey: 'fullName',
  };
  Clientconfig = { ...selectConfig, placeholder: 'Search Client', noResultsFound: "Type here to search" };
  Dealconfig = { ...selectConfig, placeholder: 'Search Deal', noResultsFound: "Client Has No Deal" };

  addTaskForm = this.formBuilder.group({
    taskName: new FormControl('', [Validators.required, noWhitespaceValidator]),
    remindDate: new FormControl('', Validators.required),
    remindTime: new FormControl('', Validators.required),
    assignedUserID: new FormControl(''),
    taskDescription: new FormControl('', Validators.required),
    client: new FormControl('', Validators.required),
    deal: new FormControl(''),
  })

  constructor(
    private signup_service: SignupLoginService,
    private formBuilder: FormBuilder,
    private generalSrv: GeneralService,
    private generalTaskSrv: GeneralTaskService,
    private emailClientService: EmailClientService,
    private dealServ: DealsService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe(info => {
      this.user = info.user;
    });
  }

  ngOnInit() {
    this.fetchUsersBySupervisor();
  }

  /**
   * Fetch users attached to a supervisor
   */
  private fetchUsersBySupervisor() {
    const getSurbodinates = this.signup_service.fetchTaskSubordinates(this.user.email).pipe(map(subs => {
      const res = subs.filter((person) => person.salesPerson == "true");
      const result = res.concat(this.user);
      return result.map(sub => ({
        id: `${sub.id}`,
        salesPerson: `${sub.salesPerson}`,
        fullName: `${sub.firstName} ${sub.lastName}`
      }))
    }));
    forkJoin([getSurbodinates]).subscribe(responses => {
      this.supervisorAttachedUsers = responses[0];
    });
  }

  /**
   * Add Task
   */
  onAddTask() {
    this.addTask();
  }

  /**
   * Add Task
   */
  private addTask() {
    this.isLoading = true
    if (this.addTaskForm.valid) {
      this.generalTaskSrv.createTask(this.addTaskForm.getRawValue()).subscribe(() => {
        this.isLoading = false;
        $("#closeAddTaskModal").click();
        this.generalSrv.sweetAlertSucess('Your Task Has Been Created');
        this.addTaskForm.reset({ assignedUserID: 'Select Salesperson' });
        this.addTaskForm.patchValue({ assignedUserID: '' })
        this.addTaskForm.controls['client'].patchValue([]);
        this.addTaskForm.controls['deal'].patchValue([]);
      }, (error) => {
        this.isLoading = false;
        $("#closeAddTaskModal").click();
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      })
    }
  }

  clientLookUp(value) {
    const inputText = value.trim()
    if (!inputText) {
      this.clearSuggestedUsers();
      return;
    }
    this.Clientconfig.noResultsFound = 'No results found!'
    const leads_lookup = this.emailClientService.fetchClientsByWildcard(value, "leads");
    const contacts_lookup = this.emailClientService.fetchClientsByWildcard(value, "contacts");
    const companies_lookup = this.emailClientService.fetchClientsByWildcard(value, "companies");
    forkJoin([leads_lookup, contacts_lookup, companies_lookup]).subscribe(
      (responses: any) => {
        let lookUp = [];

        if (responses[0].success) {
          lookUp = [...lookUp, ...responses[0].payload]
        }

        if (responses[1]) {
          lookUp = [...lookUp, ...responses[1].payload]
        }

        if (responses[2]) {
          lookUp = [...lookUp, ...responses[2].payload]
        }

        this.clientList = inputText.trim() ? [...lookUp] : [];
      })

  }

  clearSuggestedUsers() {
    this.clientList = [];
  }

  updateNoResultText() {
    const el = document.querySelector('.ngx-dropdown-container .ngx-dropdown-list-container ul li:last-child')
    el.textContent = 'No results found!'
  }

  getClientDeals() {
    this.addTaskForm.patchValue({ deal: '' });
    const clientInfo = this.addTaskForm.value.client;
    if (this.addTaskForm.value.client = !undefined) {
      this.dealList$ = this.dealServ.getAllContactDeals("client", clientInfo.clientId || clientInfo.id)
    }
  }
}
